import 'babel-polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/style/style.scss'
import '@/assets/style/basic.css'
import ElementUI from 'element-ui';
import request from './utils/request';
// import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/elementStyle/index.css'
import 'remixicon/fonts/remixicon.css'
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;


import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);



import jquery from 'jquery'
//统一缩略图
Vue.prototype.getImgThum = function(img){
	if(img){
		return img+'.thum'+img.substring(img.lastIndexOf("."))
	}
}

//日期格式化
/**
 *  filters.js
 * 对Date的扩展，将 Date 转化为指定格式的String  默认是2019-11-25 14:00:00 需要格式则后续传值
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
 * (new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2019-11-25 08:09:04.423
 * (new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2019-11-25 8:9:4.18
 * 使用格式,dom上 {{formatTime(time,'YYYY-MM-DD')}}
 * 在script中 this.formatTime(this.time,"hh:mm:ss")
 * 
 */
Date.prototype.Format = function(fmt) {
	var o = {
		"M+": this.getMonth() + 1, //月份
		"D+": this.getDate(), //日
		"h+": this.getHours(), //小时
		"m+": this.getMinutes(), //分
		"s+": this.getSeconds(), //秒
		"q+": Math.floor((this.getMonth() + 3) / 3), //季度
		"S": this.getMilliseconds() //毫秒
	};
	if (/(Y+)/.test(fmt))
		fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o)
		if (new RegExp("(" + k + ")").test(fmt))
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	return fmt;
}
const formatTime = function (times, pattern) {
	var d = new Date(times).Format("YYYY-MM-DD hh:mm:ss");
	if (pattern) {
		d = new Date(times).Format(pattern);
	}
	var timss = times+''
	if(timss.indexOf('*')>-1){
		return times
	}else{
		return d.toLocaleString();
	}
}
 export default formatTime
Vue.prototype.formatTime = formatTime;
//导航字数多了显示前6+....

Vue.prototype.navTxtMore = function(txt){
	if(txt.length > 6){
		return txt.slice(0, 6) + '...'
	}else{
		return txt
	}
}


// 图片拖拽
import VueDND from 'awe-dnd'
Vue.use(VueDND)


Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.prototype.request = request;
Vue.prototype.$ = jquery


router.afterEach((to,from,next)=>{
    window.scrollTo(0,0);
})

// 防止重复点击
import preventClick from './utils/clickStatefrom'  // 根据自己的路径
Vue.use(preventClick)


//防止缓存
const version = require('../package.json').version
const versionStorage = localStorage.getItem('version')
console.log('最新版本', 'v' + version)
console.log('缓存版本', 'v' + versionStorage)

if (version != versionStorage) {
  localStorage.setItem('version', version)
  console.log('版本不一致，清除缓存中')
  //location.reload() 方法用来刷新当前页面。该方法只有一个参数，当值为 true 时，将强制浏览器从服务器加载页面资源，
  //当值为 false 或者未传参时，浏览器则可能从缓存中读取页面。
  setTimeout(() => {
    window.location.reload(true)
  }, 1000)
}

//防止缓存




new Vue({
	router,
	store,
	render: h => h(App),
}).$mount('#app')